import { render, staticRenderFns } from "./EntityCreate.vue?vue&type=template&id=464f24b0"
import script from "./EntityCreate.vue?vue&type=script&lang=js"
export * from "./EntityCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports